const authPrefix = '/auth';
const appsPrefix = '/app';

const routesByName = {
  ui: '/ui',
  auth: {
    index: authPrefix,
    signUp: `${authPrefix}/sign-up`,
    forgotten: `${authPrefix}/forgotten`,
  },
  apps: {
    index: '/',
    createApp: `${appsPrefix}-new`,
    detail: {
      index: (id = ':id') => `${appsPrefix}/${id}`,
      distribution: (id = ':id') => `${appsPrefix}/${id}/distribution`,
      webhooks: (id = ':id') => `${appsPrefix}/${id}/webhooks`,
      webhookLogs: (id = ':id') => `${appsPrefix}/${id}/webhook-logs`,
      pricing: (id = ':id') => `${appsPrefix}/${id}/pricing`,
    },
  },
  users: `/users`,
  billing: `/billing`,
  documentation: `https://docs.timify.dev/docs`,
  apiReference: `https://docs.timify.dev/reference`,
};

export default routesByName;
